import API, {baseURL, config} from './_main';
import axios, {AxiosPromise} from 'axios';
import * as UserModule from './../Modules/UserModule';

export function LogInUser(userData: UserModule.Types.LoginRequest): AxiosPromise<UserModule.Types.LoginResponse> {
    return API.post('user/login', userData);
}

export function refreshToken(): Promise<UserModule.Types.LoginResponse> {
    return axios.post(`${baseURL}/user/refresh`, null, config()).then((response: any) => response.data);
}

export function currentUser(): AxiosPromise<{ user: UserModule.Types.UserDto }> {
    return API.get('user/current', config());
}

export function resetPassword(email: string) {
    return API.post('user/password/reset/request', { email }).then((response: any) => response.data);
}

export function resetPasswordConfirm(formData: UserModule.Types.PasswordResetRequest) {
    return API.post('user/password/reset/complete', formData, config());
}

export function changePassword(formData: UserModule.Types.ChangePasswordRequest): Promise<UserModule.Types.LoginResponse> {
    return API.post('user/password/change', formData, config()).then(response => response.data);
}

export function createNewAdmin(newUserData: UserModule.Types.CreateAdminAccountRequest) {
    return API.post('user/admin', newUserData, config());
}

export function createNewFleetOwner(newUserData: UserModule.Types.CreateFleetOwnerAccountRequest) {
    return API.post('user/fleet-owner', newUserData, config());
}

export function createNewTechnician(newUserData: UserModule.Types.CreateTechnicianAccountRequest) {
    return API.post('user/technician', newUserData, config());
}

export function createNewExternal(newUserData: UserModule.Types.CreateTechnicianAccountRequest) {
    return API.post('user/external', newUserData, config());
}

export function updateFleetOwner​(userId: number, newUserData: UserModule.Types.ModifyUFleetOwnerAccountRequest) {
    return API.put(`user/fleet-owner/${userId}`, newUserData, config());
}

export function updateTechnician(userId: number, newUserData: UserModule.Types.ModifyUTechnicianAccountRequest) {
    return API.put(`user/technician/${userId}`, newUserData, config());
}

export function updateAdmin(userId: number, newUserData: UserModule.Types.ModifyUAdminAccountRequest) {
    return API.put(`user/admin/${userId}`, newUserData, config());
}

export function updateExternal(userId: number, newUserData: UserModule.Types.ModifyUAdminAccountRequest) {
    return API.put(`user/external/${userId}`, newUserData, config());
}

export function activateUserComplete(activateUserData: UserModule.Types.ActivateUserRequest) {
    return API.post('user/activate/complete', activateUserData, config());
}

export function activateUserBegin(formData: UserModule.Types.RequestPasswordResetRequest) {
    return API.post('user/activate/begin', formData, config());
}

export function getUserList(queryParams?: Array<{ key: any; value: any }>) {
    return API.get('user', config(queryParams));
}

export function getUserById(userId: number): AxiosPromise<UserModule.Types.GetUserByIdResponse> {
    return API.get(`user/${userId}`, config());
}

export function blockUser(userId: number) {
    return API.post(`user/${userId}/block`, null, config());
}

export function unblockUser(userId: number) {
    return API.post(`user/${userId}/unblock`, null, config());
}

export function deleteUser(userId: number) {
    return API.delete(`user/${userId}`, config());
}

export function getFleetUsers(queryParams?: URLSearchParams): AxiosPromise<UserModule.Types.UserListDataResponse> {
    return API.get(`user/fleet-users`, config(queryParams));
}



// WEBPACK FOOTER //
// ./src/Connectors/UserConnector.ts